// Auto-generated skeleton for Document

import { DocumentType } from './DocumentType'
import { DocumentContainer } from './DocumentContainer'

export const Document: Api.Document = {
	id: 0,
	hp_id: null,
	ts: 0,
	poc: null,
	file_type: 0,
	file_notes: null,
	posting_year: 0,
	group: 0,
	is_public: null,
	is_internal: null,
	is_attachment: false,
	is_inline: false,
	webupload: null,
	container_id: 0,
	pages: 0,
	file_hash_name: null,
	file_original_name: null,
	file_size: 0,
	file_checksum_md5: null,
	file_checksum_sha1: null,
	created: null,
	updated: null,
	document_type: DocumentType,
	document_container: DocumentContainer,
}
